// import { useEffect, useMemo, useState } from "react";
// import { Plus, Search, Loader2, AlertCircle, Wrench, IndianRupee, PackageCheck, ImageOff, Pencil, Trash2 } from "lucide-react";
// import AddMachineModal from "./Addmachinemodal.jsx";
// import { getMachines, createMachine, updateMachine, deleteMachine } from "../service/Vendorservisefile/facilityService.jsx";

// const VENDOR_ID = 1;

// const STATUS_STYLES = {
//   AVAILABLE: "bg-green-100 text-green-700",
//   IN_USE: "bg-blue-100 text-blue-700",
//   MAINTENANCE: "bg-amber-100 text-amber-700",
//   UNAVAILABLE: "bg-red-100 text-red-700",
// };

// function StatCard({ icon: Icon, label, value, tone }) {
//   return (
//     <div className="flex items-center gap-4 rounded-2xl border border-gray-200 bg-white p-5">
//       <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${tone}`}>
//         <Icon className="h-5 w-5" />
//       </span>
//       <div>
//         <p className="text-2xl font-bold text-gray-900">{value}</p>
//         <p className="text-sm text-gray-500">{label}</p>
//       </div>
//     </div>
//   );
// }

// function MachineThumbnail({ images, name }) {
//   const [failed, setFailed] = useState(false);
//   const src = Array.isArray(images) && images.length > 0 ? images[0] : null;

//   if (!src || failed) {
//     return (
//       <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-300">
//         <ImageOff className="h-5 w-5" />
//       </div>
//     );
//   }

//   return (
//     <img
//       src={src}
//       alt={name || "Machine"}
//       onError={() => setFailed(true)}
//       className="h-12 w-12 shrink-0 rounded-lg border border-gray-100 object-cover"
//     />
//   );
// }

// export default function FacilitiesManagement() {
//   const [machines, setMachines] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [query, setQuery] = useState("");

//   // Add modal
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState(null);

//   // Edit modal
//   const [editingMachine, setEditingMachine] = useState(null); // holds the machine being edited, or null
//   const [updating, setUpdating] = useState(false);
//   const [updateError, setUpdateError] = useState(null);

//   // Delete state (track which row is mid-delete so we can disable its button)
//   const [deletingId, setDeletingId] = useState(null);
//   const [deleteError, setDeleteError] = useState(null);

//   const loadMachines = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const response = await getMachines(VENDOR_ID);
//       const list = Array.isArray(response) ? response : response?.data || [];
//       setMachines(list);
//     } catch (err) {
//       console.error("Failed to fetch machines:", err);
//       setError(err.message || "Failed to load machines. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadMachines();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const counts = useMemo(() => {
//     return {
//       total: machines.length,
//       available: machines.filter((m) => m.status === "AVAILABLE").length,
//       active: machines.filter((m) => m.active).length,
//     };
//   }, [machines]);

//   const filtered = useMemo(() => {
//     if (!query.trim()) return machines;
//     const q = query.trim().toLowerCase();
//     return machines.filter((m) =>
//       [m.machineCode, m.machineName, m.make, m.model, m.serialNumber, m.categoryName]
//         .filter(Boolean)
//         .some((field) => field.toLowerCase().includes(q))
//     );
//   }, [machines, query]);

//   const handleAddMachine = async (payload, imageFile) => {
//     try {
//       setSubmitting(true);
//       setSubmitError(null);
//       await createMachine(VENDOR_ID, payload, imageFile);
//       setShowAddModal(false);
//       await loadMachines();
//     } catch (err) {
//       console.error("Failed to add machine:", err);
//       setSubmitError(err.message || "Failed to add machine. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleUpdateMachine = async (payload, imageFile) => {
//     if (!editingMachine) return;
//     try {
//       setUpdating(true);
//       setUpdateError(null);
//       await updateMachine(editingMachine.id, payload, imageFile);
//       setEditingMachine(null);
//       await loadMachines(); // refresh table with the updated machine
//     } catch (err) {
//       console.error("Failed to update machine:", err);
//       setUpdateError(err.message || "Failed to update machine. Please try again.");
//     } finally {
//       setUpdating(false);
//     }
//   };

//   const handleDeleteMachine = async (machine) => {
//     const id = machine.id;
//     if (id == null) return;

//     const confirmed = window.confirm(
//       `Delete "${machine.machineName || "this machine"}"? This can't be undone.`
//     );
//     if (!confirmed) return;

//     try {
//       setDeletingId(id);
//       setDeleteError(null);
//       await deleteMachine(id);
//       setMachines((prev) => prev.filter((m) => m.id !== id)); // optimistic remove
//     } catch (err) {
//       console.error("Failed to delete machine:", err);
//       setDeleteError(err.message || "Failed to delete machine. Please try again.");
//       await loadMachines(); // resync in case the optimistic removal was wrong
//     } finally {
//       setDeletingId(null);
//     }
//   };

//   return (
//     <div className="h-screen w-full overflow-y-auto bg-gray-50">
//       <div className="p-6">
//         <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
//           <div>
//             <h1 className="text-2xl font-bold text-gray-900">Machines</h1>
//             <p className="mt-1 text-sm text-gray-500">Manage the machines listed under your vendor account</p>
//           </div>
//           <button
//             type="button"
//             onClick={() => setShowAddModal(true)}
//             className="flex items-center gap-2 rounded-xl bg-gradient-to-r from-indigo-600 to-blue-500 px-5 py-2.5 text-sm font-semibold text-white transition hover:opacity-90"
//           >
//             <Plus className="h-4 w-4" />
//             Add Machine
//           </button>
//         </div>

//         {error && (
//           <div className="mb-4 flex items-center gap-3 rounded-xl border border-red-200 bg-red-50 p-4 text-red-700">
//             <AlertCircle size={20} />
//             <span>{error}</span>
//           </div>
//         )}

//         {deleteError && (
//           <div className="mb-4 flex items-center gap-3 rounded-xl border border-red-200 bg-red-50 p-4 text-red-700">
//             <AlertCircle size={20} />
//             <span>{deleteError}</span>
//           </div>
//         )}

//         <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
//           <StatCard icon={Wrench} label="Total machines" value={loading ? "—" : counts.total} tone="bg-indigo-50 text-indigo-500" />
//           <StatCard icon={PackageCheck} label="Available" value={loading ? "—" : counts.available} tone="bg-green-50 text-green-500" />
//           <StatCard icon={IndianRupee} label="Active listings" value={loading ? "—" : counts.active} tone="bg-blue-50 text-blue-500" />
//         </div>

//         <div className="w-full rounded-2xl border border-gray-200 bg-white shadow-sm">
//           <div className="flex flex-col gap-4 border-b border-gray-100 p-6 sm:flex-row sm:items-center sm:justify-between">
//             <div>
//               <h2 className="text-lg font-bold text-gray-900">Machine list</h2>
//               <p className="mt-1 text-sm text-gray-500">
//                 {loading ? "Loading machines..." : `${filtered.length} of ${machines.length} machines`}
//               </p>
//             </div>

//             <div className="relative">
//               <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
//               <input
//                 type="text"
//                 value={query}
//                 onChange={(e) => setQuery(e.target.value)}
//                 placeholder="Search machines..."
//                 disabled={loading}
//                 className="w-64 rounded-lg border border-gray-200 bg-gray-50 py-2 pl-9 pr-3 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-gray-300 focus:bg-white disabled:opacity-50"
//               />
//             </div>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="w-full min-w-[1320px] table-fixed border-collapse text-left">
//               <thead>
//                 <tr className="bg-gray-50 text-xs uppercase tracking-wide text-gray-400">
//                   <th className="w-[7%] px-6 py-3 font-medium">Image</th>
//                   <th className="w-[16%] px-6 py-3 font-medium">Machine</th>
//                   <th className="w-[12%] px-6 py-3 font-medium">Model</th>
//                   <th className="w-[12%] px-6 py-3 font-medium">Serial No.</th>
//                   <th className="w-[10%] px-6 py-3 font-medium">Category</th>
//                   <th className="w-[8%] px-6 py-3 font-medium">Rate/hr</th>
//                   <th className="w-[6%] px-6 py-3 font-medium">Qty</th>
//                   <th className="w-[10%] px-6 py-3 font-medium">Status</th>
//                   <th className="w-[9%] px-6 py-3 font-medium">Active</th>
//                   <th className="w-[10%] px-6 py-3 font-medium text-right">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading && (
//                   <tr>
//                     <td colSpan={10} className="px-6 py-12 text-center text-gray-400">
//                       <div className="flex items-center justify-center gap-2">
//                         <Loader2 size={18} className="animate-spin" />
//                         Loading machines...
//                       </div>
//                     </td>
//                   </tr>
//                 )}

//                 {!loading &&
//                   filtered.map((m, idx) => (
//                     <tr
//                       key={m.id ?? m.machineCode ?? idx}
//                       className={`text-sm ${idx !== filtered.length - 1 ? "border-b border-gray-100" : ""}`}
//                     >
//                       <td className="px-6 py-4">
//                         <MachineThumbnail images={m.images} name={m.machineName} />
//                       </td>
//                       <td className="px-6 py-4">
//                         <p className="font-semibold text-gray-900">{m.machineName || "—"}</p>
//                         <p className="mt-0.5 text-xs text-gray-400">{m.machineCode || "—"}</p>
//                       </td>
//                       <td className="px-6 py-4 text-gray-600">{m.model || "—"}</td>
//                       <td className="px-6 py-4 text-gray-600">{m.serialNumber || "—"}</td>
//                       <td className="px-6 py-4 text-gray-600">{m.categoryName || "—"}</td>
//                       <td className="px-6 py-4 font-medium text-gray-900">
//                         ₹{Number(m.hourlyRate || 0).toLocaleString("en-IN")}
//                       </td>
//                       <td className="px-6 py-4 text-gray-600">{m.quantity ?? "—"}</td>
//                       <td className="px-6 py-4">
//                         <span
//                           className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${STATUS_STYLES[m.status] || "bg-gray-100 text-gray-600"
//                             }`}
//                         >
//                           {(m.status || "—").replace("_", " ")}
//                         </span>
//                       </td>
//                       <td className="px-6 py-4">
//                         <span
//                           className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${m.active ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"
//                             }`}
//                         >
//                           {m.active ? "Active" : "Inactive"}
//                         </span>
//                       </td>
//                       <td className="px-6 py-4">
//                         <div className="flex items-center justify-end gap-2">
//                           <button
//                             type="button"
//                             onClick={() => setEditingMachine(m)}
//                             className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-500 transition hover:border-indigo-300 hover:text-indigo-600"
//                             title="Edit machine"
//                           >
//                             <Pencil className="h-4 w-4" />
//                           </button>
//                           <button
//                             type="button"
//                             onClick={() => handleDeleteMachine(m)}
//                             disabled={deletingId === m.id}
//                             className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-500 transition hover:border-red-300 hover:text-red-600 disabled:opacity-50"
//                             title="Delete machine"
//                           >
//                             {deletingId === m.id ? (
//                               <Loader2 className="h-4 w-4 animate-spin" />
//                             ) : (
//                               <Trash2 className="h-4 w-4" />
//                             )}
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}

//                 {!loading && !error && filtered.length === 0 && (
//                   <tr>
//                     <td colSpan={10} className="px-6 py-10 text-center text-sm text-gray-400">
//                       No machines found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {showAddModal && (
//         <div>
//           {submitError && (
//             <div className="fixed inset-x-0 top-4 z-[60] mx-auto flex w-fit items-center gap-2 rounded-xl border border-red-200 bg-red-50 px-4 py-2 text-sm text-red-700 shadow">
//               <AlertCircle className="h-4 w-4" />
//               {submitError}
//             </div>
//           )}
//           <AddMachineModal
//             onClose={() => !submitting && setShowAddModal(false)}
//             onSubmit={handleAddMachine}
//             submitting={submitting}
//           />
//         </div>
//       )}

//       {editingMachine && (
//         <div>
//           {updateError && (
//             <div className="fixed inset-x-0 top-4 z-[60] mx-auto flex w-fit items-center gap-2 rounded-xl border border-red-200 bg-red-50 px-4 py-2 text-sm text-red-700 shadow">
//               <AlertCircle className="h-4 w-4" />
//               {updateError}
//             </div>
//           )}
//           {/* Reusing AddMachineModal in edit mode via initialData — see note below */}
//           <AddMachineModal
//             initialData={editingMachine}
//             onClose={() => !updating && setEditingMachine(null)}
//             onSubmit={handleUpdateMachine}
//             submitting={updating}
//           />
//         </div>
//       )}
//     </div>
//   );
// }




import { useMemo, useState } from "react";
import {
  Plus,
  Search,
  AlertCircle,
  Wrench,
  IndianRupee,
  PackageCheck,
  ImageOff,
  Pencil,
  Trash2,
  X,
} from "lucide-react";

/* ==========================================================
   Static dummy data — no API / service file involved.
   Replace this array whenever you want to change what shows up.
   ========================================================== */
const INITIAL_MACHINES = [
  {
    id: 1,
    machineCode: "MC-1001",
    machineName: "CNC Vertical Milling Machine",
    model: "VMC-850",
    serialNumber: "SN-88213",
    categoryName: "CNC Machining",
    hourlyRate: 1800,
    quantity: 3,
    status: "AVAILABLE",
    active: true,
    images: [],
  },
  {
    id: 2,
    machineCode: "MC-1002",
    machineName: "Laser Cutting Machine",
    model: "LX-4000",
    serialNumber: "SN-77410",
    categoryName: "Sheet Metal",
    hourlyRate: 2500,
    quantity: 2,
    status: "IN_USE",
    active: true,
    images: [],
  },
  {
    id: 3,
    machineCode: "MC-1003",
    machineName: "Hydraulic Press Brake",
    model: "HPB-200T",
    serialNumber: "SN-55921",
    categoryName: "Fabrication",
    hourlyRate: 1200,
    quantity: 1,
    status: "MAINTENANCE",
    active: false,
    images: [],
  },
  {
    id: 4,
    machineCode: "MC-1004",
    machineName: "3D Printer — SLS",
    model: "ProFuse X1",
    serialNumber: "SN-33087",
    categoryName: "Additive Manufacturing",
    hourlyRate: 900,
    quantity: 4,
    status: "AVAILABLE",
    active: true,
    images: [],
  },
  {
    id: 5,
    machineCode: "MC-1005",
    machineName: "TIG Welding Station",
    model: "WeldPro T3",
    serialNumber: "SN-19045",
    categoryName: "Welding",
    hourlyRate: 700,
    quantity: 2,
    status: "UNAVAILABLE",
    active: false,
    images: [],
  },
];

const STATUS_STYLES = {
  AVAILABLE: "bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-200",
  IN_USE: "bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200",
  MAINTENANCE: "bg-amber-50 text-amber-700 ring-1 ring-inset ring-amber-200",
  UNAVAILABLE: "bg-red-50 text-red-700 ring-1 ring-inset ring-red-200",
};

const STATUS_OPTIONS = ["AVAILABLE", "IN_USE", "MAINTENANCE", "UNAVAILABLE"];

function StatCard({ icon: Icon, label, value, tone }) {
  return (
    <div className="flex items-center gap-4 rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition hover:shadow-md">
      <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${tone}`}>
        <Icon className="h-5 w-5" />
      </span>
      <div>
        <p className="text-2xl font-bold text-gray-900">{value}</p>
        <p className="text-sm text-gray-500">{label}</p>
      </div>
    </div>
  );
}

function MachineThumbnail({ images, name }) {
  const [failed, setFailed] = useState(false);
  const src = Array.isArray(images) && images.length > 0 ? images[0] : null;

  if (!src || failed) {
    return (
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-300">
        <ImageOff className="h-5 w-5" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name || "Machine"}
      onError={() => setFailed(true)}
      className="h-12 w-12 shrink-0 rounded-lg border border-gray-100 object-cover"
    />
  );
}

/* ==========================================================
   Simple, self-contained Add / Edit modal.
   No external service calls — just hands the form values
   back to the parent, which updates local state.
   ========================================================== */
function MachineFormModal({ initialData, onClose, onSubmit }) {
  const isEdit = Boolean(initialData);

  const [form, setForm] = useState({
    machineName: initialData?.machineName || "",
    machineCode: initialData?.machineCode || "",
    model: initialData?.model || "",
    serialNumber: initialData?.serialNumber || "",
    categoryName: initialData?.categoryName || "",
    hourlyRate: initialData?.hourlyRate ?? "",
    quantity: initialData?.quantity ?? "",
    status: initialData?.status || "AVAILABLE",
    active: initialData?.active ?? true,
  });

  const handleChange = (field) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.machineName.trim()) return;

    onSubmit({
      ...form,
      hourlyRate: Number(form.hourlyRate) || 0,
      quantity: Number(form.quantity) || 0,
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-lg rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
          <h3 className="text-lg font-bold text-gray-900">
            {isEdit ? "Edit Machine" : "Add Machine"}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 transition hover:bg-gray-100 hover:text-gray-600"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="max-h-[70vh] space-y-4 overflow-y-auto px-6 py-5">
          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">Machine name</label>
            <input
              type="text"
              value={form.machineName}
              onChange={handleChange("machineName")}
              placeholder="e.g. CNC Vertical Milling Machine"
              required
              className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm outline-none focus:border-indigo-300 focus:bg-white"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Machine code</label>
              <input
                type="text"
                value={form.machineCode}
                onChange={handleChange("machineCode")}
                placeholder="MC-1006"
                className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm outline-none focus:border-indigo-300 focus:bg-white"
              />
            </div>
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Model</label>
              <input
                type="text"
                value={form.model}
                onChange={handleChange("model")}
                className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm outline-none focus:border-indigo-300 focus:bg-white"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Serial number</label>
              <input
                type="text"
                value={form.serialNumber}
                onChange={handleChange("serialNumber")}
                className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm outline-none focus:border-indigo-300 focus:bg-white"
              />
            </div>
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Category</label>
              <input
                type="text"
                value={form.categoryName}
                onChange={handleChange("categoryName")}
                className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm outline-none focus:border-indigo-300 focus:bg-white"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Rate / hr (₹)</label>
              <input
                type="number"
                min="0"
                value={form.hourlyRate}
                onChange={handleChange("hourlyRate")}
                className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm outline-none focus:border-indigo-300 focus:bg-white"
              />
            </div>
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Quantity</label>
              <input
                type="number"
                min="0"
                value={form.quantity}
                onChange={handleChange("quantity")}
                className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm outline-none focus:border-indigo-300 focus:bg-white"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Status</label>
              <select
                value={form.status}
                onChange={handleChange("status")}
                className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm outline-none focus:border-indigo-300 focus:bg-white"
              >
                {STATUS_OPTIONS.map((s) => (
                  <option key={s} value={s}>
                    {s.replace("_", " ")}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex items-end pb-2">
              <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <input
                  type="checkbox"
                  checked={form.active}
                  onChange={handleChange("active")}
                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                />
                Active listing
              </label>
            </div>
          </div>

          <div className="flex items-center justify-end gap-3 border-t border-gray-100 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-gray-200 px-4 py-2 text-sm font-medium text-gray-600 transition hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="rounded-lg bg-gradient-to-r from-indigo-600 to-blue-500 px-5 py-2 text-sm font-semibold text-white transition hover:opacity-90"
            >
              {isEdit ? "Save changes" : "Add machine"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function FacilitiesManagement() {
  // Static local state — seeded from dummy data, no fetch/service call.
  const [machines, setMachines] = useState(INITIAL_MACHINES);
  const [query, setQuery] = useState("");

  const [showAddModal, setShowAddModal] = useState(false);
  const [editingMachine, setEditingMachine] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [notice, setNotice] = useState(null);

  const counts = useMemo(() => {
    return {
      total: machines.length,
      available: machines.filter((m) => m.status === "AVAILABLE").length,
      active: machines.filter((m) => m.active).length,
    };
  }, [machines]);

  const filtered = useMemo(() => {
    if (!query.trim()) return machines;
    const q = query.trim().toLowerCase();
    return machines.filter((m) =>
      [m.machineCode, m.machineName, m.model, m.serialNumber, m.categoryName]
        .filter(Boolean)
        .some((field) => field.toLowerCase().includes(q))
    );
  }, [machines, query]);

  const showNotice = (text) => {
    setNotice(text);
    setTimeout(() => setNotice(null), 2500);
  };

  const handleAddMachine = (payload) => {
    const newMachine = {
      ...payload,
      id: Date.now(),
      images: [],
    };
    setMachines((prev) => [newMachine, ...prev]);
    setShowAddModal(false);
    showNotice("Machine added.");
  };

  const handleUpdateMachine = (payload) => {
    if (!editingMachine) return;
    setMachines((prev) =>
      prev.map((m) => (m.id === editingMachine.id ? { ...m, ...payload } : m))
    );
    setEditingMachine(null);
    showNotice("Machine updated.");
  };

  const handleDeleteMachine = (machine) => {
    const confirmed = window.confirm(
      `Delete "${machine.machineName || "this machine"}"? This can't be undone.`
    );
    if (!confirmed) return;

    setDeletingId(machine.id);
    setMachines((prev) => prev.filter((m) => m.id !== machine.id));
    setDeletingId(null);
    showNotice("Machine deleted.");
  };

  return (
    <div className="h-screen w-full overflow-y-auto bg-gray-50">
      <div className="mx-auto max-w-[1440px] p-6">
        {/* Header */}
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-gray-900">Machines</h1>
            <p className="mt-1 text-sm text-gray-500">
              Manage the machines listed under your vendor account
            </p>
          </div>
          <button
            type="button"
            onClick={() => setShowAddModal(true)}
            className="flex items-center gap-2 rounded-xl bg-gradient-to-r from-indigo-600 to-blue-500 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:opacity-90"
          >
            <Plus className="h-4 w-4" />
            Add Machine
          </button>
        </div>

        {/* Toast-style notice */}
        {notice && (
          <div className="mb-4 flex items-center gap-3 rounded-xl border border-emerald-200 bg-emerald-50 p-3 text-sm font-medium text-emerald-700">
            <PackageCheck size={18} />
            {notice}
          </div>
        )}

        {/* Stat cards */}
        <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
          <StatCard icon={Wrench} label="Total machines" value={counts.total} tone="bg-indigo-50 text-indigo-500" />
          <StatCard icon={PackageCheck} label="Available" value={counts.available} tone="bg-green-50 text-green-500" />
          <StatCard icon={IndianRupee} label="Active listings" value={counts.active} tone="bg-blue-50 text-blue-500" />
        </div>

        {/* Table card */}
        <div className="w-full rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="flex flex-col gap-4 border-b border-gray-100 p-6 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h2 className="text-lg font-bold text-gray-900">Machine list</h2>
              <p className="mt-1 text-sm text-gray-500">
                {`${filtered.length} of ${machines.length} machines`}
              </p>
            </div>

            <div className="relative">
              <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search machines..."
                className="w-64 rounded-lg border border-gray-200 bg-gray-50 py-2 pl-9 pr-3 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-gray-300 focus:bg-white"
              />
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full min-w-[1320px] table-fixed border-collapse text-left">
              <thead>
                <tr className="bg-gray-50 text-xs uppercase tracking-wide text-gray-400">
                  <th className="w-[7%] px-6 py-3 font-medium">Image</th>
                  <th className="w-[16%] px-6 py-3 font-medium">Machine</th>
                  <th className="w-[12%] px-6 py-3 font-medium">Model</th>
                  <th className="w-[12%] px-6 py-3 font-medium">Serial No.</th>
                  <th className="w-[10%] px-6 py-3 font-medium">Category</th>
                  <th className="w-[8%] px-6 py-3 font-medium">Rate/hr</th>
                  <th className="w-[6%] px-6 py-3 font-medium">Qty</th>
                  <th className="w-[10%] px-6 py-3 font-medium">Status</th>
                  <th className="w-[9%] px-6 py-3 font-medium">Active</th>
                  <th className="w-[10%] px-6 py-3 font-medium text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((m, idx) => (
                  <tr
                    key={m.id ?? m.machineCode ?? idx}
                    className={`text-sm transition hover:bg-gray-50/80 ${
                      idx !== filtered.length - 1 ? "border-b border-gray-100" : ""
                    }`}
                  >
                    <td className="px-6 py-4">
                      <MachineThumbnail images={m.images} name={m.machineName} />
                    </td>
                    <td className="px-6 py-4">
                      <p className="font-semibold text-gray-900">{m.machineName || "—"}</p>
                      <p className="mt-0.5 text-xs text-gray-400">{m.machineCode || "—"}</p>
                    </td>
                    <td className="px-6 py-4 text-gray-600">{m.model || "—"}</td>
                    <td className="px-6 py-4 text-gray-600">{m.serialNumber || "—"}</td>
                    <td className="px-6 py-4 text-gray-600">{m.categoryName || "—"}</td>
                    <td className="px-6 py-4 font-medium text-gray-900">
                      ₹{Number(m.hourlyRate || 0).toLocaleString("en-IN")}
                    </td>
                    <td className="px-6 py-4 text-gray-600">{m.quantity ?? "—"}</td>
                    <td className="px-6 py-4">
                      <span
                        className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${
                          STATUS_STYLES[m.status] || "bg-gray-100 text-gray-600"
                        }`}
                      >
                        {(m.status || "—").replace("_", " ")}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${
                          m.active ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"
                        }`}
                      >
                        {m.active ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center justify-end gap-2">
                        <button
                          type="button"
                          onClick={() => setEditingMachine(m)}
                          className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-500 transition hover:border-indigo-300 hover:text-indigo-600"
                          title="Edit machine"
                        >
                          <Pencil className="h-4 w-4" />
                        </button>
                        <button
                          type="button"
                          onClick={() => handleDeleteMachine(m)}
                          disabled={deletingId === m.id}
                          className="flex h-8 w-8 items-center justify-center rounded-lg border border-gray-200 text-gray-500 transition hover:border-red-300 hover:text-red-600 disabled:opacity-50"
                          title="Delete machine"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}

                {filtered.length === 0 && (
                  <tr>
                    <td colSpan={10} className="px-6 py-10 text-center text-sm text-gray-400">
                      No machines found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showAddModal && (
        <MachineFormModal
          onClose={() => setShowAddModal(false)}
          onSubmit={handleAddMachine}
        />
      )}

      {editingMachine && (
        <MachineFormModal
          initialData={editingMachine}
          onClose={() => setEditingMachine(null)}
          onSubmit={handleUpdateMachine}
        />
      )}
    </div>
  );
}